import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';

import FormAlumno from '../forms/form_alumno';
import { insertEstudiante } from '../actions';

class Registro extends Component {
  constructor(props){
      super(props);

      this.submitForm = this.submitForm.bind(this);
  }

  submitForm(data){
    this.props.insertEstudiante(data);
  }

  render(){

    if(this.props.usuario && this.props.usuario.nombres !== undefined){
      NotificationManager.success("Usuario ya registrado", "Registrado");
      return <Redirect to="/" />;
    }
    return (
      <section id="form-alumno">
        <div className="container">
          <h1>Registrar Usuario</h1>
          <hr />
          <FormAlumno submitText="Registrase"
            submit={this.submitForm}/>
        </div>
      </section>
    );
  }
}

function mapStateToProps({ usuario }) {
  return { usuario };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    insertEstudiante
  }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(Registro);



// WEBPACK FOOTER //
// ./src/containers/registro.js